export const LOCAL_STORAGE_DATA_KEYS = {
  AUTH_KEY: 'key',
  AUTH_TOKEN: 'token',

}
